import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects `}{` `}{` `}<img parentName="h2" {...{
        "src": "photos/rsz_clipartkey_2776772.png",
        "alt": "Graduation Photo",
        "title": "Joshua Cheung"
      }}></img></h2>
    <ProjectCard title="Multi-threaded Server" link="https://github.com/joshuacheung/ServerProject" bg="linear-gradient(to right, #383535 0%, #141313 100%)" mdxType="ProjectCard">
Created a server able to handle REST API calls in C++ <br></br><br></br>
    </ProjectCard>
    <ProjectCard title="Bit Vector" link="https://github.com/joshuacheung/Bit-Vector-Project" bg="linear-gradient(to right, #383535 0%, #141313 100%)" mdxType="ProjectCard">
Inputs bit vectors and determines whether they are prime or composite in addition to determining whether it is a perfect number.
    </ProjectCard>
    <ProjectCard title="Chess Simulator" link="https://github.com/joshuacheung/Chess-Simulator" bg="linear-gradient(to right, #383535 0%, #141313 100%)" mdxType="ProjectCard">
Developed a chessboard simulation with multiple chess piece subclasses to determine if certain moves were possible. Used multiple data structures to conserve data storage and memory</ProjectCard>
    <ProjectCard title="Othello with AI" link="https://github.com/joshuacheung/Othello-" bg="linear-gradient(to right, #383535 0%, #141313 100%)" mdxType="ProjectCard">
Implemented Othello game with AI and visible GUI<br></br><br></br><br></br></ProjectCard>
    <h3>{`(more at `}<a parentName="h3" {...{
        "href": "https://github.com/joshuacheung"
      }}>{`github.com/joshuacheung`}</a>{`)`}</h3>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      